export const Keyboard = {
    ArrowDown: 'ArrowDown',
    ArrowUp: 'ArrowUp',
    Escape: 'Escape',
    Home: 'Home',
    End: 'End',
} as const
